var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" "+_vm._s(_vm.question)+" ")])],1)],1),_vm._t("default",null,{"loading":_vm.loading,"accept":_vm.accept})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }